var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',[(_vm.loading)?_c('v-card-text',{staticClass:"d-flex align-center justify-center",staticStyle:{"height":"450px"}},[_c('v-progress-circular',{attrs:{"size":70,"width":7,"color":"teal darken-3","indeterminate":""}})],1):[_vm._t("default")]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }